import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { GridConfig } from '@inavista/components/grid';
import { centreStatusColumns } from 'projects/service/src/app/shared/utils/grid-status-align';

// Link Service Orders popup (Cycle Counts popup, Inventory transfer request popup, Dashboard) on @inavista/components.
// Same checkbox column, columns, labels, order, widths, alignment and toolbar (Columns, Search, Excel export for
// AllGrid_Toolbar_Excel_Export, Clear filters) as the Syncfusion grid it replaces. Rows: GET
// getServiceOrdersForTransferOrder (unchanged), served by LocalRowsGridApi. No paging (Martin): the grid scrolls.

export const LINK_SERVICE_ORDERS_URL = 'page://link-service-orders';
export const LINK_SERVICE_ORDERS_PERSISTENCE_KEY = 'rims.service.link-service-orders-service-orders';

export const LINK_SERVICE_ORDERS_COLUMNS: [string, string][] = [
  ['serviceOrderId', 'nvarchar'],
  ['serviceOrderIdLN', 'nvarchar'],
  ['customerDescription', 'nvarchar'],
  ['status', 'nvarchar'],
  ['itemDescription', 'nvarchar'],
];

const ORDER = LINK_SERVICE_ORDERS_COLUMNS.map(([c]) => c);

export function buildLinkServiceOrdersGridConfig(canExport: boolean): GridConfig {
  return centreStatusColumns({
    apiBaseUrl: LINK_SERVICE_ORDERS_URL,
    clientSide: true,
    keyColumn: 'serviceOrderId',
    rowHeight: 30,
    // The old checkbox column (multi-select), 55 wide.
    selectable: true,
    selectColumnWidth: 55,
    defaultColumnOrder: ORDER,
    columnLabels: {
      serviceOrderId: 'Order ID', serviceOrderIdLN: 'LN Order No', customerDescription: 'Service Order Customer',
      status: 'Status', itemDescription: 'Item',
    },
    // Every column left, as the old grid.
    columnAlign: Object.fromEntries(ORDER.map(c => [c, { horizontal: 'left' as const, header: { horizontal: 'left' as const } }])),
    // The old widths; LN Order No and Service Order Customer had none and shared the rest.
    columnWidths: { serviceOrderId: 120, serviceOrderIdLN: 150, customerDescription: 150, status: 150, itemDescription: 350 },
    stretchColumns: true,
    columnSizing: { serviceOrderId: { noStretch: true }, status: { noStretch: true }, itemDescription: { noStretch: true } },
    // The old toolbar: Columns, Search, Excel export (AllGrid_Toolbar_Excel_Export only), Clear filters.
    enableColumnsPicker: true,
    enableExport: canExport,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableResetLayout: true,
    enableRefresh: false,
    enableFooter: false,
    // Ctrl+click adds a sort column, as the old grid (Syncfusion multi-sort).
    multiSort: true,
    emptyStateMessage: 'No records to display',
    // Right-click a cell filters by its value (Martin, 2026-10-29: every grid that filters).
    enableContextMenuFilter: true,
    persistenceKey: LINK_SERVICE_ORDERS_PERSISTENCE_KEY,
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  });
}
